
import Product from "@/types/Product";
import { defineComponent, PropType, ref } from "vue";
import Modal from "../General/Modal.vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiClose, mdiLoading } from "@mdi/js";
import { Inertia } from "@inertiajs/inertia";
import Messages from "../General/Messages.vue";
import TextButton from "../Buttons/TextButton.vue";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: () => false,
    },
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },
  emits: ["dismiss"],
  setup(props, context) {
    const deleteLoading = ref(false);

    const deleteProduct = () => {
      deleteLoading.value = true;

      Inertia.delete(route("products.destroy", { product: props.product.id }), {
        onFinish: () => {
          deleteLoading.value = false;
          context.emit("dismiss");
        },
      });
    };

    return {
      deleteProduct,
      deleteLoading,
      closeIcon: mdiClose,
      loadingIcon: mdiLoading,
    };
  },
  components: { Modal, Button, SvgIcon, Messages, TextButton },
});
